import { useEffect } from 'react';

import { useFormDataQuery } from '@/api/getters';
import OfferPage from '@/features/v2/summaryForms/components/offer/OfferPage';
import ThankYouContactCostEstimate from '@/features/v2/vehicle-damage/components/thankYou/ThankYouContactCostEstimate';
import ThankYouContactUs from '@/features/v2/vehicle-damage/components/thankYou/ThankYouContactUs';
import { VehicleDamageSchemaDeadEndsStepOne } from '@/features/v2/vehicle-damage/stepsSchema';
import {
  getUserType,
  vehicleDamageDataLayer,
} from '@/helpers/addStageToDataLyer';

const ContactUs = () => {
  // This component uses data directly from the backend (which is ensured to be the same due to revalidation)
  // instead of using the 'watch' function. This is because this component is higher in the hierarchy than the form component.
  const { data } = useFormDataQuery();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formData = data?.payload?.data as Record<any, any>;

  const COST_ESTIMATE =
    VehicleDamageSchemaDeadEndsStepOne.noAccidentReportedToInsurer.condition(
      formData
    );

  const WITH_OFFER =
    (data?.offer?.offer_rejected === true ||
      data?.offer?.offer_rejected === false) &&
    !data?.offer?.is_complementary;

  const userType = getUserType(data);

  useEffect(() => {
    // The offer branch reuses the contact_us stage but is not a disqualification.
    if (WITH_OFFER) return;
    if (COST_ESTIMATE) {
      vehicleDamageDataLayer.notQualified(
        'brak_zgłoszenia_do_ubezpieczyciela',
        'contact_us',
        userType
      );
      return;
    }
    vehicleDamageDataLayer.notQualified('contact_us', 'contact_us', userType);
  }, [WITH_OFFER, COST_ESTIMATE, userType]);

  if (WITH_OFFER) {
    return <OfferPage />;
  }

  if (COST_ESTIMATE) {
    return <ThankYouContactCostEstimate />;
  }

  return <ThankYouContactUs />;
};

export default ContactUs;
